import React from 'react';

import { Modal, Body } from 'components/Modals/modalElements';
import { FooterButton } from 'components/Modals/FreecodeModals/FreecodeAuthModal/freecodeModalElements';
import { List, ListItem, CheckIcon, CourseModalHeading } from './styles';

export default React.memo(({ list, onSignUp, onClose }) => {
  return (
    <Modal isCourseBenefitModal isFreecodeModal>
      <Body isCourseBenefitModal>
        <CourseModalHeading>Your free benefits</CourseModalHeading>
        <List>
          {list.map((item, index) => {
            return (
              <ListItem key={index}>
                <CheckIcon className="fa-solid fa-check" />
                {item}
              </ListItem>
            );
          })}
        </List>
        <FooterButton isFreecodeAuthSecondaryButton onClick={onSignUp}>
          Sign Up
        </FooterButton>
        <FooterButton isFreecodeAuthCancelButton onClick={onClose}>
          Cancel
        </FooterButton>
      </Body>
    </Modal>
  );
});
